import React from "react";
import { useFormContext, Controller } from "react-hook-form";

import { DatePickerMonth } from "components";
import { FilterColumnDateProps } from "types";

import styles from "../filter.module.scss";

type FilterColumnProps = {
	column: FilterColumnDateProps;
};

const FilterMonthYearPicker = ({ column }: FilterColumnProps) => {
	const { control, setValue } = useFormContext();

	return (
		<Controller
			control={control}
			name={column.name || ""}
			defaultValue={null}
			render={({ field: { name, value } }) => (
				<DatePickerMonth
					name={name}
					value={value}
					onChange={value => {
						setValue(name, value);
					}}
					placeholderText={column.placeholder}
					className={styles.column}
					minDate={column.minDate}
					maxDate={column.maxDate}
				/>
			)}
		/>
	);
};

export default FilterMonthYearPicker;
